import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../../core/services/conf/auth.service';
import { MenuitemComponent } from '../menuitem/menuitem.component';
import { MENU_CONFIG, MenuItemConfig } from '../../../core/services/conf/menu.config';
import { PermissionService } from '../../../core/services/conf/permission.service';

@Component({
    selector: 'app-menu',
    imports: [MenuitemComponent, RouterModule],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent {
    model: MenuItem[] = [];

    private permissionService = inject(PermissionService);

    ngOnInit() {
        this.model = this.buildMenu(MENU_CONFIG);
    }

    private buildMenu(menuConfig: MenuItemConfig[]): MenuItem[] {
        return menuConfig.map((item) => this.processMenuItem(item)).filter((item) => item !== null) as MenuItem[];
    }

    private processMenuItem(item: MenuItemConfig): MenuItem | null {
        // Si el item tiene roles definidos, verificar acceso
        if (item.allowedRoles && !this.permissionService.hasRole(item.allowedRoles)) {
            return null;
        }

        // Procesar sub-items si existen
        if (item.items && item.items.length > 0) {
            const processedItems = item.items.map((subItem) => this.processMenuItem(subItem as MenuItemConfig)).filter((subItem) => subItem !== null) as MenuItem[];

            // Si no hay sub-items visibles, no mostrar el item padre
            if (processedItems.length === 0) {
                return null;
            }

            return {
                ...item,
                visible: true,
                items: processedItems
            };
        }

        // Item sin sub-items
        return {
            ...item,
            visible: true
        };
    }
    // model: MenuItem[] = [];

    // private authService = inject(AuthService);

    // rolUser = this.authService.getUserRole();

    // ngOnInit() {
    //     console.log(this.rolUser);
    //     this.model = [
    //         {
    //             label: 'Inicio',
    //             items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/sp'] }]
    //         },
    //         {
    //             label: 'SECCIONES',
    //             items: [
    //                 {
    //                     label: 'Préstamos',
    //                     icon: 'pi pi-fw pi-check-square',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR',
    //                     routerLink: ['/sp/loans']
    //                 },
    //                 {
    //                     label: 'Libro Caja',
    //                     icon: 'pi pi-fw pi-book',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'CONTADOR',
    //                     // class: 'rotated-icon',
    //                     routerLink: ['/sp/cash']
    //                 },
    //                 {
    //                     label: 'Clientes',
    //                     icon: 'pi pi-fw pi-id-card',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'CONTADOR',
    //                     // class: 'rotated-icon',
    //                     routerLink: ['/sp/clients']
    //                 },
    //                 {
    //                     label: 'Facturación',
    //                     icon: 'pi pi-fw pi-receipt',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR',
    //                     items: [
    //                         {
    //                             label: 'Facturas',
    //                             icon: 'pi pi-fw pi-receipt',
    //                             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                             routerLink: ['/sp/invoicing/invoice']
    //                         },
    //                         {
    //                             label: 'Recibos',
    //                             icon: 'pi pi-fw pi-file-pdf',
    //                             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                             routerLink: ['/sp/invoicing/receipt']
    //                         },
    //                         {
    //                             label: 'Notas de Crédito',
    //                             icon: 'pi pi-fw pi-file-import',
    //                             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                             routerLink: ['/sp/invoicing/creditnote']
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     label: 'Reportes',
    //                     icon: 'pi pi-fw pi-chart-line',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                     items: [
    //                         {
    //                             label: 'Reporte Prestamos',
    //                             icon: 'pi pi-fw pi-chart-scatter',
    //                             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                             routerLink: ['/sp/reports/loans']
    //                         },
    //                         {
    //                             label: 'Reporte General',
    //                             icon: 'pi pi-fw pi-chart-bar',
    //                             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                             routerLink: ['/sp/reports/general']
    //                         },
    //                         {
    //                             label: 'Reporte Mensual',
    //                             icon: 'pi pi-fw pi-chart-pie',
    //                             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                             routerLink: ['/sp/reports/monthly']
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     label: 'Calculadora Préstamos',
    //                     icon: 'pi pi-fw pi-wallet',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                     routerLink: ['/sp/calc']
    //                 }
    //             ]
    //         },
    //         {
    //             label: 'ECOMMERCE',
    //             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR' || this.rolUser === 'USUARIO',
    //             items: [
    //                 {
    //                     label: 'Ecommerce',
    //                     icon: 'pi pi-fw pi-cart-plus',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH',
    //                     routerLink: ['/sp/ec/view']
    //                 },
    //                 {
    //                     label: 'Productos',
    //                     icon: 'pi pi-fw pi-tags',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR' || this.rolUser === 'USUARIO',
    //                     routerLink: ['/sp/ec/products/management']
    //                 },
    //                 {
    //                     label: 'Ordenes',
    //                     icon: 'pi pi-fw pi-server',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR' || this.rolUser === 'USUARIO',
    //                     items: [
    //                         {
    //                             label: 'Ordenes',
    //                             icon: 'pi pi-fw pi-credit-card',
    //                             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH',
    //                             routerLink: ['/sp/ec/orders']
    //                         },
    //                         // {
    //                         //     label: 'Contado',
    //                         //     icon: 'pi pi-fw pi-dollar',
    //                         //     visible:
    //                         //         this.rolUser === 'ROOT' ||
    //                         //         this.rolUser === 'ADMIN' ||
    //                         //         this.rolUser === 'RRHH' ||
    //                         //         this.rolUser === 'ASISTENTERRHH' ||
    //                         //         this.rolUser === 'CONTADOR' ||
    //                         //         this.rolUser === 'ASISTENTECONTADOR' ||
    //                         //         this.rolUser === 'USUARIO',
    //                         //     routerLink: ['/sp/ec/orders/cash']
    //                         // },
    //                         {
    //                             label: 'Tracking Compras',
    //                             icon: 'pi pi-fw pi-truck',
    //                             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR',
    //                             routerLink: ['/sp/ec/orders/tracking']
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     label: 'Libro Caja',
    //                     icon: 'pi pi-fw pi-book',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR' || this.rolUser === 'USUARIO',
    //                     routerLink: ['/sp/ec/cashbook']
    //                 }
    //             ]
    //         },
    //         {
    //             label: 'CONFIGURACIONES',
    //             visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH' || this.rolUser === 'CONTADOR' || this.rolUser === 'ASISTENTECONTADOR' || this.rolUser === 'USUARIO',
    //             items: [
    //                 {
    //                     label: 'Categorias',
    //                     icon: 'pi pi-fw pi-th-large',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH',
    //                     routerLink: ['/sp/ec/settings/category']
    //                 },
    //                 {
    //                     label: 'Proveedores',
    //                     icon: 'pi pi-fw pi-warehouse',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN' || this.rolUser === 'RRHH' || this.rolUser === 'ASISTENTERRHH',
    //                     routerLink: ['/sp/ec/settings/supplier']
    //                 },
    //                 {
    //                     label: 'Usuarios',
    //                     icon: 'pi pi-fw pi-address-book',
    //                     visible: this.rolUser === 'ROOT' || this.rolUser === 'ADMIN',
    //                     routerLink: ['/sp/settings/user']
    //                 }
    //             ]
    //         }
    //     ];
    // }
}
